import { createFileRoute } from "@tanstack/react-router";
import { Topbar } from "@/components/calv/Topbar";
import { Footer } from "@/components/calv/Footer";
import { Hero } from "@/components/calv/Hero";
import { Section } from "@/components/calv/Section";
import { ViabilityCalculator } from "@/components/calv/ViabilityCalculator";
import { SITE_URL } from "@/lib/locale";

const TITLE = "Performance Marketing Profitability Calculator — Calvarius";
const DESC =
  "Calculates economically viable CPC thresholds from order value, margin, and conversion rate — plus reality check against industry CPC medians.";
const URL_ = `${SITE_URL}/en/tools/profitability-calculator`;
const ALT = `${SITE_URL}/tools/wirtschaftlichkeitsrechner`;

export const Route = createFileRoute("/en/tools/profitability-calculator")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL_ },
      { property: "og:locale", content: "en_US" },
      { property: "og:locale:alternate", content: "de_DE" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESC },
    ],
    links: [
      { rel: "canonical", href: URL_ },
      { rel: "alternate", hrefLang: "en", href: URL_ },
      { rel: "alternate", hrefLang: "de", href: ALT },
      { rel: "alternate", hrefLang: "x-default", href: ALT },
    ],
  }),
  component: ProfitabilityCalculatorEN,
});

function ProfitabilityCalculatorEN() {
  return (
    <>
      <Topbar />
      <main id="main">
        <Hero
          variant="short"
          number="01"
          eyebrow="PROFITABILITY CALCULATOR · PERFORMANCE MARKETING"
          headline={<>Is performance marketing <em>worth it for you?</em></>}
          lead="Calculates the economically viable CPC thresholds from your order value, margin, and conversion data — plus methodical assessment against industry reality. No marketing fluff, but economic substance."
          breadcrumbs={[
            { label: "Start", to: "/en" },
            { label: "Tools", to: "/en/tools" },
            { label: "Profitability Calculator" },
          ]}
        />

        <Section
          number="02"
          kicker="Input"
          headline={<>Five values. <em>One honest assessment.</em></>}
          variant="tinted"
        >
          <ViabilityCalculator locale="en" />
        </Section>
      </main>
      <Footer />
    </>
  );
}
